import React from "react";
import { useParams } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { Bucket } from "../../../../api/config/apiConfig";
import gifLoading from "../../../../imgs/giphy.gif";

const PrebidFormDownload = ({ formContent = {} }) => {
  const { uuid } = useParams();

  // Helper function to format the date
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return String(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    const ordinalSuffix = getOrdinalSuffix(day);

    return `${day}${ordinalSuffix} ${month}, ${year}`;
  };

  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const firstParty = formContent?.firstParty || {};
  const secondParty = formContent?.secondParty || {};
  const carDescription = formContent?.carDescription || {};
  const images = carDescription?.images || [];

  return (
    <div className="premium-print-container mx-4">
      {/* Title */}
      <div className="d-flex align-items-center justify-content-center w-100 mb-3">
        <p className="ps-0 mb-0 head-top" style={{ fontSize: "16pt", fontWeight: 800 }}>
          Prebid Agreement For Import of Vehicle
        </p>
      </div>

      {/* Meta details */}
      <div className="row mb-1">
        <div className="col-12">
          <p className="p-word mb-1 text-start">
            <b>Issue Date:</b> <span>{formContent?.issueDate || "-"}</span>
          </p>
        </div>
      </div>

      {formContent?.notice && (
        <div className="row mb-1">
          <div className="col-12">
            <p className="p-word mb-1 text-start">
              <b>Confidentiality Notice:</b> <span>{formContent.notice}</span>
            </p>
          </div>
        </div>
      )}

      <div className="row mb-1">
        <div className="col-12">
          <p className="p-word mb-1 text-start">
            <b>CONTRACT PRICE:</b> <span>{formContent?.contractPrice || "-"}</span>
          </p>
        </div>
      </div>

      <div className="row mb-2">
        <div className="col-12">
          <p className="p-word mb-1 text-start">
            <b>DATE:</b> <span>{formatDate(formContent?.date)}</span>
          </p>
        </div>
      </div>

      {/* Introduction */}
      <div className="row mb-1">
        <div className="col-12">
          <p className="p-word mb-1 text-start">
            <b>Introduction:</b>
          </p>
          <p className="p-word mb-2 text-start" style={{ lineHeight: 1.5 }}>
            This document outlines the PRE-Bidding Agreement for the Import of a
            Vehicle as per the contractual agreement established between the
            parties involved. This agreement, made at Islamabad on the date{" "}
            {formatDate(formContent?.date)}, is between:
          </p>
        </div>
      </div>

      {/* Parties */}
      <div className="row mb-2">
        <div className="col-12">
          <p className="p-word mb-1 text-start">
            <b>First Party (“Buyer”):</b>
          </p>
          <p className="p-word mb-2 text-start" style={{ lineHeight: 1.5 }}>
            <span>
              {firstParty?.name || "First Party"}{" "}
              {firstParty?.organization ? `(${firstParty.organization})` : ""}{" "}
              (Hereinafter referred to as &quot;the 1st Party&quot;, which expression
              shall, where the context so permits, include his heirs, executors,
              administrators, and assigns)
            </span>
          </p>
        </div>
      </div>

      <div className="row mb-2">
        <div className="col-12">
          <p className="p-word mb-1 text-start">
            <b>And</b>
          </p>
          <p className="p-word mb-1 text-start">
            <b>Second Party:</b>
          </p>
          <p className="p-word mb-2 text-start" style={{ lineHeight: 1.5 }}>
            <span>
              “Shelozon Movers Packers &amp; Logistics Pvt Ltd” (Hereinafter
              referred to as &quot;the 2nd Party&quot;)
            </span>
          </p>
        </div>
      </div>

      <hr />

      {/* Instructions to Bidders */}
      <div className="row mb-2">
        <div className="col-12">
          <p className="p-word mb-1 text-start">
            <b>Instructions to Bidders:</b>
          </p>
          <p className="p-word mb-1 text-start">
            <span>The 1st Party shall provide the following documents:</span>
          </p>
          <p
            className="p-word mb-2 text-start"
            style={{ whiteSpace: "pre-line", lineHeight: 1.5 }}
          >
            {formContent?.instructions || "-"}
          </p>
        </div>
      </div>

      <hr />

      {/* Inclusions */}
      <div className="row mb-2">
        <div className="col-12">
          <p className="p-word mb-1 text-start">
            <b>INCLUSIONS:</b>
          </p>
          <p className="p-word mb-1 text-start">
            <b>2nd Party:</b>{" "}
            <span>
              Is responsible for the following services and its costs are included
              in the Contract Price:
            </span>
          </p>
          <p
            className="p-word mb-2 text-start"
            style={{ whiteSpace: "pre-line", lineHeight: 1.5 }}
          >
            {formContent?.inclusions || "-"}
          </p>
        </div>
      </div>

      <hr />

      {/* Exclusions */}
      <div className="row mb-2">
        <div className="col-12">
          <p className="p-word mb-1 text-start">
            <b>EXCLUSIONS:</b>
          </p>
          <p
            className="p-word mb-2 text-start"
            style={{ whiteSpace: "pre-line", lineHeight: 1.5 }}
          >
            {formContent?.exclusions || "-"}
          </p>
        </div>
      </div>

      <hr />

      {/* Demurrage */}
      <div className="row mb-2">
        <div className="col-12">
          <p className="p-word mb-1 text-start">
            <b>Demurrage:</b>{" "}
            <span>{formContent?.demurrage || "-"}</span>
          </p>
        </div>
      </div>

      <hr />

      {/* Payment Terms */}
      <div className="row mb-2">
        <div className="col-12">
          <p className="p-word mb-1 text-start">
            <b>PAYMENT TERMS:</b>
          </p>
          <p className="p-word mb-1 text-start">
            <span>
              The payment for the import of the vehicle shall be made as follows:
            </span>
          </p>
          <p
            className="p-word mb-2 text-start"
            style={{ whiteSpace: "pre-line", lineHeight: 1.5 }}
          >
            {formContent?.paymentTerms || "-"}
          </p>
        </div>
      </div>

      <hr />

      {/* Cancellation Policy */}
      <div className="row mb-2">
        <div className="col-12">
          <p className="p-word mb-1 text-start">
            <b>CANCELLATION POLICY:</b>
          </p>
          <p className="p-word mb-1 text-start" style={{ lineHeight: 1.5 }}>
            1. In case the Buyer tends to cancel the agreement after the purchase
            and during the time of issue of the Bill of Lading, the Buyer is
            bound to pay the total amount of Contract Price.
          </p>
          <p className="p-word mb-2 text-start" style={{ lineHeight: 1.5 }}>
            2. If buyer cancels After the Issuance of Bill of Lading and before
            delivery of Vehicle, the Buyer will pay 50% of remaining amount of
            Total Contract Price.
          </p>
        </div>
      </div>

      <hr />

      {/* Appendix */}
      <div className="row mb-2">
        <div className="col-12">
          <p className="p-word mb-1 text-start">
            <b>APPENDIX:</b>
          </p>
          <p className="p-word mb-1 text-start" style={{ lineHeight: 1.5 }}>
            The 1st Party (Buyer) shall review the following documents and ensure
            their completeness:
          </p>
          <p className="p-word mb-1 text-start" style={{ lineHeight: 1.5 }}>
            <b>Pictures of the Vehicle:</b> Comprehensive photographs of the
            vehicle from various angles, including interior and exterior views.
            These pictures serve as visual documentation of the vehicle&apos;s condition
            at the time of booking.
          </p>
          <p className="p-word mb-2 text-start" style={{ lineHeight: 1.5 }}>
            <b>Auction Sheet of the Vehicle:</b> The Auction Sheet provides
            detailed information about the vehicle&apos;s specifications and condition.
          </p>
        </div>
      </div>

      <hr />

      {/* Car Description */}
      <div className="row mb-2" style={{ pageBreakInside: "avoid" }}>
        <div className="col-12">
          <p className="p-word mb-2 text-start">
            <b>Car Description:</b>
          </p>
          <div className="row">
            <div className="col-6 mb-1">
              <p className="p-word mb-0 text-start">
                <b>Make:</b>{" "}
                <span>{carDescription?.make || "-"}</span>
              </p>
            </div>
            <div className="col-6 mb-1">
              <p className="p-word mb-0 text-start">
                <b>Model:</b>{" "}
                <span>{carDescription?.model || "-"}</span>
              </p>
            </div>
            <div className="col-6 mb-1">
              <p className="p-word mb-0 text-start">
                <b>Specification:</b>{" "}
                <span>{carDescription?.specification || "-"}</span>
              </p>
            </div>
            <div className="col-6 mb-1">
              <p className="p-word mb-0 text-start">
                <b>Mileage:</b>{" "}
                <span>{carDescription?.mileage || "-"}</span>
              </p>
            </div>
            {carDescription?.year && (
              <div className="col-6 mb-1">
                <p className="p-word mb-0 text-start">
                  <b>Year:</b>{" "}
                  <span>{carDescription.year}</span>
                </p>
              </div>
            )}
            {carDescription?.grade && (
              <div className="col-6 mb-1">
                <p className="p-word mb-0 text-start">
                  <b>Grade:</b>{" "}
                  <span>{carDescription.grade}</span>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Vehicle Images */}
      {images && images.length > 0 && (
        <div className="my-3" style={{ pageBreakInside: "auto" }}>
          <p className="p-word mb-2 text-start">
            <b>Vehicle Photos &amp; Documents:</b>
          </p>
          <div className="row">
            {images.map((image, index) => {
              const imgKey =
                typeof image === "string"
                  ? image
                  : image?.key || image?.url || "";
              const imgSrc = imgKey?.startsWith("http")
                ? imgKey
                : `${Bucket}${imgKey}`;
              const caption = typeof image === "object" ? image?.caption : "";
              const category = typeof image === "object" ? image?.category : "";

              return (
                <div key={index} className="col-6 mb-3" style={{ pageBreakInside: "avoid" }}>
                  <img
                    src={imgSrc}
                    alt={`Vehicle Photo ${index + 1}`}
                    crossOrigin="anonymous"
                    style={{
                      width: "100%",
                      maxHeight: "240px",
                      objectFit: "contain",
                      borderRadius: "6px",
                      border: "1px solid #e2e8f0",
                    }}
                  />
                  {(caption || category) && (
                    <p className="text-muted small mt-1 mb-0 text-start">
                      <b>Photo #{index + 1}:</b> {caption ? caption : ""}{" "}
                      {category ? `(${category.toUpperCase()})` : ""}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      {formContent?.importantNote && (
        <>
          <hr />
          <div className="row mb-2">
            <div className="col-12">
              <p className="p-word mb-1 text-start">
                <b>Important Note:</b> <span>{formContent.importantNote}</span>
              </p>
            </div>
          </div>
        </>
      )}

      <hr />

      {/* Parties Info & Signatures */}
      <div className="signature-section my-3" style={{ pageBreakInside: "avoid" }}>
        <div className="row mb-2">
          <div className="col-6">
            <p className="p-word mb-1 text-start">
              <b>First Party (Buyer)</b>
            </p>
            <p className="p-word mb-0 text-start small">
              <b>Name:</b> {firstParty?.name || "-"}
            </p>
            <p className="p-word mb-0 text-start small">
              <b>Email:</b> {firstParty?.email || "-"}
            </p>
            <p className="p-word mb-0 text-start small">
              <b>MOFA ID NO:</b> {firstParty?.mofaIdNo || "-"}
            </p>
            <p className="p-word mb-0 text-start small">
              <b>Organization:</b> {firstParty?.organization || "-"}
            </p>
          </div>

          <div className="col-6">
            <p className="p-word mb-1 text-start">
              <b>Second Party</b>
            </p>
            <p className="p-word mb-0 text-start small">
              <b>Name:</b> {secondParty?.name || "Shelozon Logistics"}
            </p>
            <p className="p-word mb-0 text-start small">
              <b>Email:</b> {secondParty?.email || "info@shelozon.com"}
            </p>
            <p className="p-word mb-0 text-start small">
              <b>Organization:</b> {secondParty?.organization || "Shelozon Movers Packers & Logistics Pvt Ltd"}
            </p>
          </div>
        </div>

        {/* Signature Blocks */}
        <Row className="mt-4">
          <Col sm={6} className="text-center">
            <div
              style={{ height: "90px" }}
              className="d-flex justify-content-center align-items-end"
            >
              {firstParty?.sign ? (
                <img
                  src={
                    firstParty.sign.startsWith("http")
                      ? firstParty.sign
                      : `${Bucket}${firstParty.sign}`
                  }
                  height={80}
                  style={{ maxWidth: "200px", objectFit: "contain" }}
                  alt="First Party Signature"
                  crossOrigin="anonymous"
                />
              ) : (
                <div style={{ height: "80px" }}></div>
              )}
            </div>
            <p className="mb-0">_______________________________</p>
            <p className="my-0">
              <b>First Party Signature</b>
            </p>
          </Col>

          <Col sm={6} className="text-center">
            <div
              style={{ height: "90px" }}
              className="d-flex justify-content-center align-items-end"
            >
              {secondParty?.sign ? (
                <img
                  src={
                    secondParty.sign.startsWith("http")
                      ? secondParty.sign
                      : `${Bucket}${secondParty.sign}`
                  }
                  height={80}
                  style={{ maxWidth: "200px", objectFit: "contain" }}
                  alt="Second Party Signature"
                  crossOrigin="anonymous"
                />
              ) : (
                <div style={{ height: "80px" }}></div>
              )}
            </div>
            <p className="mb-0">_______________________________</p>
            <p className="my-0">
              <b>Shelozon Movers Packers &amp; Logistics Pvt Ltd</b>
            </p>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default PrebidFormDownload;
